import { render, staticRenderFns } from "./product-roles-role-form.vue?vue&type=template&id=6005c3ce"
import script from "./product-roles-role-form.vue?vue&type=script&lang=js"
export * from "./product-roles-role-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports